module.exports = __webpack_public_path__ + "static/p14_pajaritos-3ef473ded100bfe7387e24f5d44e72e4.png";